import { Component } from '@angular/core';

@Component({ templateUrl: './cutting_table-shell.component.html' })
export class CuttingTableShellComponent {}
